<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          editMode: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:error="errorHandler"
      />
  
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
  
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import IRCaseMaintenanceForm from "../../../components/industrialrelations/ircasemaintenance/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": IRCaseMaintenanceForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('ircasemaintenance.editircasemaintenance'),
      pageTitleValue: "",
      formData: {
        recorddate: null,
        incidentdate: null,
        caseid: null,
        shortdesc: null,
        longdesc: null,
        incidentcatid: null,
        irincidentcatcode: null,
        reportedbyid: null,
        remarks: null,
        casestatusid: null,
        statusremarks: null,
        attach: null,
        attachname: null,
        attachdesc: null,
        docid: null,
        documents: [],
        docdid: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      document: [],
      documentdetail: [],
      
      
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadIRMaintenance() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/ircasemaintenance/" + this.id})
        .then((res) => {
          if (res.data.rec[0].recorddate) {
            vm.formData.recorddate = moment(res.data.rec[0].recorddate).format(
              "YYYY-MM-DD"
            );
          }

          if (res.data.rec[0].incidentdate) {
            vm.formData.incidentdate = moment(res.data.rec[0].incidentdate).format(
              "YYYY-MM-DD"
            );
          }
          
          vm.formData.id = res.data.rec[0].id;
          vm.formData.caseid = res.data.rec[0].caseid;
          vm.formData.shortdesc = res.data.rec[0].shortdesc;
          vm.formData.longdesc = res.data.rec[0].longdesc;
          vm.formData.incidentcatid = res.data.rec[0].incidentcatid;
          vm.formData.irincidentcatcode = res.data.rec[0].irincidentcatcode;
          vm.formData.longdesc = res.data.rec[0].longdesc;
          vm.formData.reportedbyid = res.data.rec[0].reportedbyid;
          vm.formData.staffcode = res.data.rec[0].staffcode
          vm.formData.compnyname = res.data.rec[0].compnyname,
          vm.formData.remarks = res.data.rec[0].remarks;
          vm.formData.casestatusid = res.data.rec[0].casestatusid;
          vm.formData.statusremarks = res.data.rec[0].statusremarks;
          vm.formData.attach = res.data.rec[0].attach;
          vm.formData.attachname = res.data.rec[0].attachname;
          vm.formData.attachdesc = res.data.rec[0].attachdesc;
          // vm.formData.lockstaff = res.data.rec[0].lockstaff;
      
          vm.pageTitleValue = res.data.rec[0].caseid;
          vm.formData.stamp = res.data.rec[0].stamp;
          vm.formData.userid = this.$store.getters.userId;

          //vm.loading = false;
          vm.loadIRMaintenanceDocument();
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadIRMaintenanceDocument() {
      const vm = this;
      this.$store.dispatch('get', {url: "/irdocument/" + this.formData.id})
        .then((res) => {
          vm.document = res.data.rec;
          console.log('document', vm.document)
          if (res.data.rec.length > 0) {
            vm.formData.attachdesc = res.data.rec[0].attachdesc;  
            this.formData.docid = res.data.rec[0].id;
            vm.loadIRMaintenanceDocumentDetail();
          } else {
            vm.loading = false;
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadIRMaintenanceDocumentDetail() {
      const vm = this;

      this.$store.dispatch('get', {url: "/irdocumentdetail/" + this.formData.id})
        .then((res) => {
          vm.documentdetail = res.data.rec;

          for (let i = 0; i < vm.documentdetail.length; i++) {
            vm.formData.documents.push(vm.documentdetail[i])
            vm.formData.documents[i].no = i
            vm.formData.docdid.push(vm.documentdetail[i].id)
          }
          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      console.log('data: ', this.formData)

      this.$store.dispatch('put', {url: "/ircasemaintenance/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "ircasemaintenancelist" , params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

      this.$store.dispatch('delete', {url:"/ircasemaintenance/" + this.id + "/" + this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "ircasemaintenancelist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "ircasemaintenancenew" });
    },
  },

  async mounted() {
    await this.loadIRMaintenance();
  },
};
</script>